import { useAuth } from 'web/src/auth/useAuth'
import {
  EXTENSION_INSTALLED_STORAGE_KEY,
  USER_GOAL_STATE
} from '../../constants'
import { reallyTruthy } from '../../validation'

export const useGoalsState = () => {
  const { user } = useAuth()
  const extensionInstalled = reallyTruthy(
    window.localStorage.getItem(EXTENSION_INSTALLED_STORAGE_KEY)
  )

  if (!user) return { extensionInstalled }

  return {
    onboardingComplete:
      [USER_GOAL_STATE.SKIP_FOR_NOW, USER_GOAL_STATE.COMPLETED].includes(
        user.goals.userOnboarding
      ) &&
      [USER_GOAL_STATE.SKIP_FOR_NOW, USER_GOAL_STATE.COMPLETED].includes(
        user.goals.productOnboarding
      ),
    userOnboardingRequired:
      user.goals.userOnboarding === USER_GOAL_STATE.REQUIRED,
    productOnboardingRequired:
      user.goals.productOnboarding === USER_GOAL_STATE.REQUIRED,
    userOnboardingSkipped:
      user.goals.userOnboarding === USER_GOAL_STATE.SKIP_FOR_NOW,
    productOnboardingSkipped:
      user.goals.productOnboarding === USER_GOAL_STATE.SKIP_FOR_NOW,
    makeFirstMoteRequired:
      user.goals.makeFirstMote === USER_GOAL_STATE.REQUIRED,
    isLoopOptInCompleted: user.goals.loopOptIn === USER_GOAL_STATE.COMPLETED,
    isLoopOptInSkipped: user.goals.loopOptIn === USER_GOAL_STATE.SKIP_FOR_NOW,
    isLoopOptInRequired: user.goals.loopOptIn === USER_GOAL_STATE.REQUIRED,
    isLoopOptInDismissed: user.goals.loopOptIn === USER_GOAL_STATE.DISMISSED,
    canSchoolSearchDuringUserOnboarding:
      user.goals.schoolSearchDuringUserOnboarding !==
      USER_GOAL_STATE.SKIP_FOR_NOW,
    extensionInstalled
  }
}
